export default {"src":"/_next/static/media/facebook.f22d6a9c.svg","height":24,"width":24};